import { FC, Fragment } from 'react';

import { TProductItemConfig } from '@/components/modules/orders-page/orders/ui/product-item';
import { EOrderStatus } from '@/types/orders';

import { useTranslate } from '@/shared/hooks/use-translate';

import * as Styled from './styled';

type TProps = {
    onModalDetailsPayment: () => void;
    onModalCalendarPayment: () => void;
    config: TProductItemConfig;
};

export const ButtonDetail: FC<TProps> = ({ onModalDetailsPayment, onModalCalendarPayment, config }) => {
    const { t } = useTranslate();

    switch (true) {
        case config.status !== EOrderStatus.Approved && config.status !== EOrderStatus.Active:
            return (
                <Styled.Wrapper $status={config.status}>
                    <Styled.ButtonWrapper onClick={onModalDetailsPayment}>{t('Детали оплаты')}</Styled.ButtonWrapper>
                    {config.termUnit === 2 && (
                        <Styled.ButtonWrapper onClick={onModalCalendarPayment}>
                            {t('Календарь платежей')}
                        </Styled.ButtonWrapper>
                    )}
                </Styled.Wrapper>
            );

        case config.status === 'closed':
            return (
                <Styled.Wrapper $status={config.status}>
                    <Styled.ButtonWrapper onClick={onModalDetailsPayment} stretch>
                        {t('Детали оплаты')}
                    </Styled.ButtonWrapper>
                </Styled.Wrapper>
            );
        default:
            return <></>;
    }
};
